import { Component, OnInit, inject } from '@angular/core';
import { Router } from '@angular/router';
import { AuthenticationService } from '../../../features/authentication/services/authentication.service';
import { TranslationService } from '../../translations/services/translation.service';

@Component({
  selector: 'app-access-denied',
  templateUrl: './access-denied.component.html',
  styleUrls: ['./access-denied.component.scss'],
  standalone: false
})
export class AccessDeniedComponent implements OnInit {
  private readonly router = inject(Router);
  private readonly authService = inject(AuthenticationService);
  public readonly translationService = inject(TranslationService);

  protected reason: string;

  ngOnInit(): void {
    // Unauthenticated users should never see this page — send them straight to login
    if (!this.authService.isAuthenticated()) {
      this.router.navigate(['/authlogin']);
      return;
    }
    this.reason = history.state?.reason ?? this.translationService.translate('accessDeniedMessageText');
  }

  goToHome(): void {
    this.router.navigate(['/home/dashboard']);
  }
}
